import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreUsers } from "../../api/apiUsers";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للمستخدمين
 */
export function useRestoreAllUsers() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllUsersMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreUsers,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore users");
        },
    });

    return {
        restoreAllUsersMutate,
        isPending,
    };
}